import React  from 'react'
import DropDown from '../dropdown';
import { PriceLists } from '../../../api/services/next'

const PriceGroupsDropDown = ({...rest}) => {
    return <DropDown api={PriceLists.GetPriceGroups} search textField="Name" valueField="Id"  {...rest}/>
}

export default PriceGroupsDropDown

